export default class Accordion {
	constructor() {
		this.button = '.accordion__itemTitle';
		this.content = '.accordion__itemContent';

		this.toggleEvent = null;
	}

	init() {
		if ($('.accordion').length) {
			this.toggleEvent = this.toggleAccordion.bind(this);

			$('body').on('click', this.button, this.toggleEvent);
		}

		/* if ($('.accordion__item').length > 3) {
            $('.accordion__item').each(function(index) {
                if (index < 3) {
                    $(this).css('display', 'block');
                } else {
                    $(this).css('display', 'none');
                }
            });

            $.fn.toggleText = function(text1, text2) {
                return this.each(function() {
                    const $this = $(this);
                    $this.html($this.html().includes(text1) ? text2 : text1);
                });
            };

            $('.button__btn-wrap .button').click(function(e) {
                e.preventDefault();

                const $this = $(this);
                const $accordion = $this.closest('.accordion');
                const $items = $accordion.find('.accordion__item');

                if ($items.filter(':visible').length > 3) {
                    $items.hide().slice(0, 3).fadeIn();
                    $this.html("See more <i class='fa-solid fa-chevron-right'></i>");

                    $('html, body').animate({
                        scrollTop: $accordion.offset().top - 50
                    }, 1000);
                } else {
                    $items.fadeIn();
                    $this.html("Show less <i class='fa-solid fa-chevron-right'></i>");
                }
            });
        } */
	}

	toggleAccordion(event) {
		const currentAccordion = $(event.target).closest('.accordion__item');
		const currentContent = $(currentAccordion).find('.accordion__itemContent');

		$('.accordion__item').not(currentAccordion).removeClass('active');

		$(this.content).not(currentContent).slideUp();

		$(currentAccordion).toggleClass('active').find('.accordion__itemContent').slideToggle();
	}

	destroy() {
		$('body').off('click', this.button, this.toggleEvent);
	}
}
